// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Homepage Styles - Based on Figma Design
   ========================================== */

/* Fonts - AvenirNext for INTUIT */
@font-face {
  font-family: 'AvenirNext forINTUIT';
  src: local('Avenir Next');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'AvenirNext forINTUIT';
  src: local('Avenir Next');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'AvenirNext forINTUIT';
  src: local('Avenir Next');
  font-weight: 900;
  font-style: normal;
}

/* CSS Variables - Exact colors from Figma */
:root {
  /* Primary Colors */
  --color-primary-white: #FFFFFF;
  --color-primary-super-blue: #1C60EA;
  --color-intuit-blue: #246BFD;
  
  /* Secondary Colors */
  --color-secondary-gray-1: rgba(0, 37, 74, 0.07);
  --color-secondary-gray-3: rgba(0, 37, 74, 0.3);
  --color-secondary-pepper-120: #21262A;
  --color-text-dark: #3C4347;
  
  /* Brand Colors */
  --color-dark-blue: #00254B;
  --color-dark-navy: #002049;
  --color-purple-dark: #3B0065;
  --color-orange-accent: #F5A623;
  
  /* Fonts */
  --font-avenir: 'AvenirNext forINTUIT', 'Avenir Next', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* Homepage Container */
.homepage {
  width: 100%;
  min-height: 100vh;
  background: var(--color-primary-white);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* Hero Section */
.hero-section {
  flex: 1;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  overflow: hidden;
}

/* Hero Background */
.hero-background {
  position: absolute;
  inset: 0;
  z-index: 0;
  background-color: #3B0065;
  overflow: hidden;
}

.figures-bg {
  position: absolute;
  top: -20%;
  left: 0;
  width: 100%;
  height: 120%;
  object-fit: cover;
  object-position: center top;
}

.gradient-overlay {
  display: none;
}

/* Decorative Type Elements */
.type-decoration {
  position: absolute;
  pointer-events: none;
}

.type-decoration-1 {
  width: 1.6em;
  height: auto;
  /* Position top-left of Finlit */
  top: -0.9em;
  left: -1.7em;
  object-fit: contain;
}

.type-decoration-2 {
  width: 1.6em;
  height: auto;
  /* Position bottom-right of "Fun." */
  bottom: -0.4em;
  right: -1.9em;
  object-fit: contain;
}

/* Hero Content */
.hero-content {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1440px;
  padding: 0 100px;
  gap: 100px;
}

/* Tagline */
.tagline-container {
  flex: 1;
}

.tagline {
  font-family: var(--font-avenir);
  font-weight: 900;
  font-size: 104px;
  line-height: 1.1;
  letter-spacing: -0.04em;
  color: var(--color-primary-white);
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);
}

.tagline span {
  display: block;
}

.tagline span.finlit-line,
.tagline span.fun-line {
  position: relative;
  display: inline-block;
}

/* CTA Container */
.cta-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
}

.hof-logo {
  width: 264px;
  height: auto;
}

.get-started-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 183px;
  padding: 14px 24px;
  background: var(--color-dark-blue);
  border: none;
  border-radius: 9999px;
  font-family: var(--font-avenir);
  font-weight: 600;
  font-size: 16px;
  line-height: 1.75;
  color: var(--color-primary-white);
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.get-started-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.3);
}

.get-started-btn:active {
  transform: translateY(0);
}

/* Responsive Styles */
@media (max-width: 1200px) {
  .hero-content {
    padding: 0 60px;
    gap: 60px;
  }

  .tagline {
    font-size: 80px;
  }
}

@media (max-width: 992px) {
  .nav-content {
    padding: 16px 24px;
  }

  .hero-content {
    flex-direction: column;
    padding: 60px 40px;
    gap: 40px;
  }

  .tagline {
    font-size: 64px;
  }

  .type-decoration {
    display: none;
  }
}

@media (max-width: 768px) {
  .browser-frame {
    height: 80px;
  }

  .tagline {
    font-size: 48px;
  }

  .hof-logo {
    width: 200px;
  }

  .get-started-btn {
    width: 160px;
  }
}

@media (max-width: 480px) {
  .nav-content {
    padding: 12px 16px;
  }

  .nav-logo img {
    height: 32px;
  }

  .hero-content {
    padding: 40px 24px;
  }

  .tagline {
    font-size: 36px;
  }

  .hof-logo {
    width: 160px;
  }

  .cta-container {
    gap: 32px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/Homepage.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C,kCAAkC;AAClC;EACE,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,mCAAmC;EACnC,4BAA4B;;EAE5B,qBAAqB;EACrB,+CAA+C;EAC/C,8CAA8C;EAC9C,qCAAqC;EACrC,0BAA0B;;EAE1B,iBAAiB;EACjB,0BAA0B;EAC1B,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;;EAE9B,UAAU;EACV,+GAA+G;AACjH;;AAEA,uBAAuB;AACvB;EACE,WAAW;EACX,iBAAiB;EACjB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,OAAO;EACP,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA,YAAY;AACZ;EACE,OAAO;AACT;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAS;EACX;AACF","sourcesContent":["/* ==========================================\n   Homepage Styles - Based on Figma Design\n   ========================================== */\n\n/* Fonts - AvenirNext for INTUIT */\n@font-face {\n  font-family: 'AvenirNext forINTUIT';\n  src: local('Avenir Next');\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'AvenirNext forINTUIT';\n  src: local('Avenir Next');\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: 'AvenirNext forINTUIT';\n  src: local('Avenir Next');\n  font-weight: 900;\n  font-style: normal;\n}\n\n/* CSS Variables - Exact colors from Figma */\n:root {\n  /* Primary Colors */\n  --color-primary-white: #FFFFFF;\n  --color-primary-super-blue: #1C60EA;\n  --color-intuit-blue: #246BFD;\n  \n  /* Secondary Colors */\n  --color-secondary-gray-1: rgba(0, 37, 74, 0.07);\n  --color-secondary-gray-3: rgba(0, 37, 74, 0.3);\n  --color-secondary-pepper-120: #21262A;\n  --color-text-dark: #3C4347;\n  \n  /* Brand Colors */\n  --color-dark-blue: #00254B;\n  --color-dark-navy: #002049;\n  --color-purple-dark: #3B0065;\n  --color-orange-accent: #F5A623;\n  \n  /* Fonts */\n  --font-avenir: 'AvenirNext forINTUIT', 'Avenir Next', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n}\n\n/* Homepage Container */\n.homepage {\n  width: 100%;\n  min-height: 100vh;\n  background: var(--color-primary-white);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n/* Hero Section */\n.hero-section {\n  flex: 1;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  overflow: hidden;\n}\n\n/* Hero Background */\n.hero-background {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  background-color: #3B0065;\n  overflow: hidden;\n}\n\n.figures-bg {\n  position: absolute;\n  top: -20%;\n  left: 0;\n  width: 100%;\n  height: 120%;\n  object-fit: cover;\n  object-position: center top;\n}\n\n.gradient-overlay {\n  display: none;\n}\n\n/* Decorative Type Elements */\n.type-decoration {\n  position: absolute;\n  pointer-events: none;\n}\n\n.type-decoration-1 {\n  width: 1.6em;\n  height: auto;\n  /* Position top-left of Finlit */\n  top: -0.9em;\n  left: -1.7em;\n  object-fit: contain;\n}\n\n.type-decoration-2 {\n  width: 1.6em;\n  height: auto;\n  /* Position bottom-right of \"Fun.\" */\n  bottom: -0.4em;\n  right: -1.9em;\n  object-fit: contain;\n}\n\n/* Hero Content */\n.hero-content {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  max-width: 1440px;\n  padding: 0 100px;\n  gap: 100px;\n}\n\n/* Tagline */\n.tagline-container {\n  flex: 1;\n}\n\n.tagline {\n  font-family: var(--font-avenir);\n  font-weight: 900;\n  font-size: 104px;\n  line-height: 1.1;\n  letter-spacing: -0.04em;\n  color: var(--color-primary-white);\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-shadow: 0 4px 30px rgba(0, 0, 0, 0.3);\n}\n\n.tagline span {\n  display: block;\n}\n\n.tagline span.finlit-line,\n.tagline span.fun-line {\n  position: relative;\n  display: inline-block;\n}\n\n/* CTA Container */\n.cta-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 48px;\n}\n\n.hof-logo {\n  width: 264px;\n  height: auto;\n}\n\n.get-started-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 183px;\n  padding: 14px 24px;\n  background: var(--color-dark-blue);\n  border: none;\n  border-radius: 9999px;\n  font-family: var(--font-avenir);\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.75;\n  color: var(--color-primary-white);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n.get-started-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 30px rgba(0, 0, 0, 0.3);\n}\n\n.get-started-btn:active {\n  transform: translateY(0);\n}\n\n/* Responsive Styles */\n@media (max-width: 1200px) {\n  .hero-content {\n    padding: 0 60px;\n    gap: 60px;\n  }\n\n  .tagline {\n    font-size: 80px;\n  }\n}\n\n@media (max-width: 992px) {\n  .nav-content {\n    padding: 16px 24px;\n  }\n\n  .hero-content {\n    flex-direction: column;\n    padding: 60px 40px;\n    gap: 40px;\n  }\n\n  .tagline {\n    font-size: 64px;\n  }\n\n  .type-decoration {\n    display: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .browser-frame {\n    height: 80px;\n  }\n\n  .tagline {\n    font-size: 48px;\n  }\n\n  .hof-logo {\n    width: 200px;\n  }\n\n  .get-started-btn {\n    width: 160px;\n  }\n}\n\n@media (max-width: 480px) {\n  .nav-content {\n    padding: 12px 16px;\n  }\n\n  .nav-logo img {\n    height: 32px;\n  }\n\n  .hero-content {\n    padding: 40px 24px;\n  }\n\n  .tagline {\n    font-size: 36px;\n  }\n\n  .hof-logo {\n    width: 160px;\n  }\n\n  .cta-container {\n    gap: 32px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
